// Bootstrap 3 is a local copy rather than an npm dependency: it is EOL with two unpatchable
// XSS advisories, both in JavaScript plugins this app does not load. The README beside the
// stylesheet covers why the version cannot move and what the copy has to contain.
import './third-party/bootstrap-3.4.1/css/bootstrap.min.css'
import { Layout } from './Layout';
import { SchemaProvider } from './SchemaProvider';
import './App.css';

function App() {
  return (
    <SchemaProvider>
      <Layout />
    </SchemaProvider>
  );
}

export default App;
